module.exports = __webpack_public_path__ + "assets/img/bunny.007d40af.png";